import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class SmoothScroll {
	constructor() {
		if (SmoothScroll.instance) return SmoothScroll.instance

		this._lenis = null
		this.options = {}
		this.tickerCallback = null
		this.#init()

		SmoothScroll.instance = this
	}

	#init() {
		this.#registerScrollTrigger()
		this.#initLenis()
		this.#addGsapTicker()
	}

	#initLenis() {
		this.options = { allowNestedScroll: true }
		this._lenis = new Lenis(this.options)
	}

	#addGsapTicker() {
		this._lenis.on('scroll', ScrollTrigger.update)
		this.tickerCallback = time => {
			this._lenis.raf(time * 1000)
		}
		gsap.ticker.add(this.tickerCallback)
		gsap.ticker.lagSmoothing(0)
	}

	#registerScrollTrigger() {
		gsap.registerPlugin(ScrollTrigger)
	}

	get lenis() {
		return this._lenis
	}

	destroy() {
		if (this.tickerCallback) {
			gsap.ticker.remove(this.tickerCallback)
			this.tickerCallback = null
		}
		if (this._lenis) {
			this._lenis.destroy()
			this._lenis = null
		}
		SmoothScroll.instance = null
	}
}
